import { compareMeasureLabels } from "@app/utils/helper"
import { getJobByLocation } from "@app/utils/inspection"

const psaElement =
	{
		elementType: "radioSwitcherList",
		label: "Schutzausrüstung (PSA)",
		id: "standardgefaehrdungen_psa",
		name: "standardgefaehrdungen_psa",
		headerLabel: "wird gestellt von",
		entries: [],
		"validation": {
			"required": false,
			"type": "object",
			"extendedJsonValidation": "",
			"validationErrorMessage": ""
		},
		"condition": {
			"extendedJsonCondition": "",
			"conditionElementIdentifier": "",
			"conditionMatches": ""
		},
		radioOptions: [
			{
				label: "Nicht erforderlich",
				value: "Nicht erforderlich",
			},
			{
				label: "Tempton",
				value: "Tempton",
			},
			{
				label: "Kunde",
				value: "Kunde",
			},
		],
	}
const precautionElement = {
	elementType: "radioSwitcherList",
	label: "Vorsorgen",
	id: "standardgefaehrdungen_vorsorgen",
	name: "standardgefaehrdungen_vorsorgen",
	headerLabel: "wird angeboten von",
	entries: [],
	"validation": {
		"required": false,
		"type": "object",
		"extendedJsonValidation": "",
		"validationErrorMessage": ""
	},
	"condition": {
		"extendedJsonCondition": "",
		"conditionElementIdentifier": "",
		"conditionMatches": ""
	},
	radioOptions: [
		{
			label: "Nicht erforderlich",
			value: "Nicht erforderlich",
		},
		{
			label: "Tempton",
			value: "Tempton",
		},
		{
			label: "Kunde",
			value: "Kunde",
		},
	],
}
const instructionsElement = {
	elementType: "radioSwitcherList",
	label: "Unterweisungen",
	id: "standardgefaehrdungen_unterweisungen",
	name: "standardgefaehrdungen_unterweisungen",
	headerLabel: "wird durchgeführt von",
	entries: [],
	"validation": {
		"required": false,
		"type": "object",
		"extendedJsonValidation": "",
		"validationErrorMessage": ""
	},
	"condition": {
		"extendedJsonCondition": "",
		"conditionElementIdentifier": "",
		"conditionMatches": ""
	},
	radioOptions: [
		{
			label: "Nicht erforderlich",
			value: "Nicht erforderlich",
		},
		{
			label: "Tempton",
			value: "Tempton",
		},
	],
}
const standardPsaFieldset = {
	"subline": "",
	"identifier": "standardgefaehrdungen",
	"highlightBox": false,
	"elements": [
		psaElement,
		precautionElement,
		instructionsElement,
	]
}
export const processCustomerMeasures = (data) => {
	const emptyRes = {
		Vorsorge: [],
		PSA: [],
		Unterweisungen: [],
	}
	if (!data) return emptyRes

	let res = data.reduce((acc, entry) => {
		let newAcc = acc;
		["PSA", "Vorsorge", "Unterweisungen"].forEach(key => {
			const res = (entry[key]?.split(";") || [])
				.map(item => item.trim())
				.map(item => ({
					id: getIdFromString(item),
					label: item,
					initialValue: entry.Durch_kunde ? "Kunde" : "Tempton",
					source: "kunde"
				}))
			newAcc[key] = [...newAcc[key], ...res]
		})
		return newAcc
	}, emptyRes)

	return res
}

export function injectStandardPsaFieldset (steps) {
	const lastStep = steps?.find(({ identifier }) => identifier === "standardanforderungen")
	lastStep?.fieldsets?.unshift(standardPsaFieldset)
}

export const getIdFromString = (string) => {
	return string
	// return string.replaceAll(".", "_")
}
const DANGER_FIELD_CONFIG = [
	{
		arrayKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_psa",
		searchKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_psa_titel",
		targetKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_psa_wirdgestelltvon"
	},
	{
		arrayKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_unterweisung",
		searchKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_unterweisung_titel",
		targetKey: null, // kein replace vorgesehen
		initialValue: "Tempton"
	},
	{
		arrayKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_vorsorgen",
		searchKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_vorsorgen_titel",
		targetKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_vorsorgen_wirdangebotenvon",
	},
	{
		arrayKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_angebotsvorsorgen",
		searchKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_angebotsvorsorgen_titel",
		targetKey: "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_angebotsvorsorgen_wirdangebotenvon",
	}
]

function getDangerEntry (values, config) {
	const { arrayKey, targetKey, initialValue } = config
	return values.physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen
		?.map(({
			[arrayKey]: entry
		}) => (entry))
		.flat()
		.map(entry => ({
			id: getIdFromString(entry[`${arrayKey}_titel__ID`]),
			label: entry[`${arrayKey}_titel__ID`],
			initialValue: targetKey ? entry[targetKey] : (initialValue ?? null),
			source: "gefährdung",
		})) || [];
}

export function processDangerMeasures (values) {
	return {
		PSA: getDangerEntry(values, DANGER_FIELD_CONFIG[0]),
		Unterweisungen: getDangerEntry(values, DANGER_FIELD_CONFIG[1]),
		Vorsorge: [...getDangerEntry(values, DANGER_FIELD_CONFIG[2]), ...getDangerEntry(values, DANGER_FIELD_CONFIG[3])],
	}
}

export function getDangerMeasureValues (dangerMeasuresObj, overwrite = true, currentValues = {}) {
	return dangerMeasuresObj.reduce((acc, { id, initialValue }) => {
		const currentValue = currentValues[getIdFromString(id)]
		return ({
			...acc,
			[getIdFromString(id)]: overwrite ? initialValue : (currentValue ?? initialValue),
		})
	}, {})
}

export function compareMeasureObj (a, b) {
	return compareMeasureLabels(a.label, b.label)
}

const buildInitialValues = (standardMeasures, customerMeasures, dangerMeasureValues = {}) => {
	return {
		...(Object.values(standardMeasures)
			.reduce((res, label) => ({
				...res,
				[getIdFromString(label)]: null,
			}), {})),
		...(customerMeasures?.reduce((res, measure) => ({
			[measure.id]: measure.initialValue || null,
		}), {}) || {}),
		...dangerMeasureValues
	}
}

export function buildInitialStandardObjects (values, office, job, dangerMeasures) {
	const { PSA: psa, Vorsorgeuntersuchung: precaution, Unterweisung: instructions } = job || {}

	const jobByLocation = getJobByLocation(values, office)
	const processedCustomerMeasures = processCustomerMeasures(jobByLocation?.Vorsorge_PSA)

	return ({
		standardgefaehrdungen_psa: buildInitialValues(psa, processedCustomerMeasures.PSA, getDangerMeasureValues(dangerMeasures.PSA)),
		standardgefaehrdungen_vorsorgen: buildInitialValues(precaution, processedCustomerMeasures.Vorsorge, getDangerMeasureValues(dangerMeasures.Vorsorge)),
		standardgefaehrdungen_unterweisungen: buildInitialValues(instructions, processedCustomerMeasures.Unterweisungen, getDangerMeasureValues(dangerMeasures.Unterweisungen, false, values.standardgefaehrdungen_unterweisungen)),
	})
}

export const updateDangerMeasures = (data, search, replaceValue) => {
	data.forEach(item => {
		DANGER_FIELD_CONFIG.forEach(({ arrayKey, searchKey, targetKey }) => {
			const arr = item[arrayKey]
			if (!arr || !targetKey) return

			arr.forEach(entry => {
				const value = entry[searchKey]
				if (value && getIdFromString(value) === search) {
					entry[targetKey] = replaceValue
				}
			})
		})
	})

	return data
}
export const uniqueByIdFilter = () => {
	const seen = new Set()
	return (item) => {
		if (seen.has(item.id)) return false
		seen.add(item.id)
		return true
	}
}
export const syncValuesIn = (updateValues, currentKeys, prevMeasures, dangerMeasures) => {
	for (const element of prevMeasures) {
		const prevId = getIdFromString(element.id)
		if (!currentKeys.includes(prevId)) {
			delete updateValues[getIdFromString(element.id)]
		}
	}
	updateValues = {
		...updateValues,
		...getDangerMeasureValues(dangerMeasures)
	}
	return updateValues
}
export const setupElements = (element, jobMeasures, customerMeasures, dangerMeasures) => {
	element.entries = Object.entries(jobMeasures)
		.map(([, label]) => ({ id: getIdFromString(label), label, source: "job" }))
		.concat(customerMeasures)
		.concat(dangerMeasures)
		.sort(compareMeasureObj)
		.filter(uniqueByIdFilter())
}